export const FETCHING_CONTACT_QUOTES = 'FETCHING_CONTACT_QUOTES'
export const GET_CONTACT_QUOTES = 'GET_CONTACT_QUOTES'
export const CLEAR_CONTACT_QUOTES = 'CLEAR_CONTACT_QUOTES'
